(function () {
    'use strict';

    angular
        .module('app.systemLog', ['ui.router'])
        .config(['$stateProvider', '$urlRouterProvider', function($stateProvider){
            $stateProvider.state('home.systemLog', {
                    requireLogin: true,
                    url: 'admin/systemLog',
                    templateUrl: 'app/admin/systemLog/systemLog.html?app_v=deployDate',
                    data: {
                        authorizedRoles: ['Administrator'],
                        navMarker: ['admin', 'systemLog']
                    },
                    params: {
                        accountDataLog: null,
                        userDataLog : null
                    },
                    controller: 'SystemLogCtrl'
                });
        }]);
})();